<template>
  <div>tween</div>
</template>

<script>
import { abstractField } from "vue-form-generator";
export default {
  mixins: [ abstractField ],
  data() {
    console.log('NEW HERE', this.value);
    if (!this.value.time) {
      this.$set(this.value, 'time', 1);
    }
    if (!this.value.loop) {
      this.$set(this.value, 'loop', false);
    }
    if (!this.value.tweens) {
      this.$set(this.value, 'tweens', []);
    }
    return {
      tweenSchema:{
        groups: [
          {
            fields:[
              {
                type:"select",
                label:"Property",
                model:"property",
                values:[
                  {name:'X',id:'x'},
                  {name:'Y',id:'y'},
                  // {name:'dX',id:'dx'},
                  // {name:'dY',id:'dy'},
                  {name:'Scale X',id:'scalex'},
                  {name:'Scale Y',id:'scaley'},
                  {name:'Scale Both Local',id:'scaleboth'},
                  {name:'Scale Both Global',id:'scalebothglobal'},
                  {name:'Scale Both Local Absolute',id:'scalebothabs'},
                  {name:'Scale X Local Absolute',id:'scalexabs'},
                  {name:'Scale Y Local Absolute',id:'scaleyabs'},
                  {name:'Scale Both Global Absolute',id:'scalebothglobalabs'},
                  {name:'Scale X Global Absolute',id:'scalexglobalabs'},
                  {name:'Scale Y Global Absolute',id:'scaleyglobalabs'},
                  {name:'Rotation',id:'rotation'},
                  // {name:'Circle Start Angle',id:'circleStartAngle'},
                  // {name:'Circle End Angle',id:'circleEndAngle'},
                  {name:'Alpha',id:'alpha'},
                  // {name:'Text',id:'text'},
                ]

              },
              {
                type: "scalar",
                inputType: "number",
                label: "Start Value",
                model: "from",
                transformData:this.schema.transformData
              },
              {
                type: "scalar",
                inputType: "number",
                label: "End Value",
                model: "to",
                transformData:this.schema.transformData
              },
              {
                type: "tween-select",
                label: "Tween",
                model: "tween",
                transformData:this.schema.transformData
              }
            ]
          }
        ],

      },
      mainSchema:{
        groups:[{
        fields:[
          {
            type: "scalar",
            inputType: "number",
            label: "Duration of Tween",
            model: "time",
            transformData:this.schema.transformData
          },
          {
            type: "scalar",
            inputType: "number",
            label: "Start Delay (s)",
            model: "startDelay",
            transformData:this.schema.transformData
          },
          {
            type: "checkbox",
            label: "Loop Tween",
            model: "loop",
            transformData:this.schema.transformData,
            default:false
          },
          {
            type: "checkbox",
            label: "Flip Tween",
            model: "flip",
            transformData:this.schema.transformData,
            default:false
          },
        ]
        }],
      },
      properties:[
        {name:'X',prop:'x'},
        {name:'Y',prop:'y'},
        {name:'dX',prop:'dx'},
        {name:'dY',prop:'dy'},
        {name:'Scale X',prop:'scalex'},
        {name:'Scale Y',prop:'scaley'},
        {name:'Scale Both',prop:'scaleboth'},
        {name:'Scale Both Absolute',prop:'scalebothabs'},
        {name:'Rotation',prop:'rotation'},
        {name:'Alpha',prop:'alpha'},
      ]
    }
  },
  methods: {
    removeTween(property) {
      this.value.tweens = this.value.tweens.filter( (x) => {
        return x !== property;
      } );
    }
  },

}
</script>

